import { useECommerceContext } from "@/components/Product/ECommerce/context/eCommerce.context";

import { Compare } from "./compare.component";

const CompareContainer = () => {
    const { product } = useECommerceContext();

    return <Compare product={product} />;
};

export { CompareContainer };
